import { isExerciseAdministrationPath } from './exerciseAdministrationPath';

export const POST_LOGIN_PATH = '/';

const APPROVAL_PATH = '/membership-approval';

export const resolvePostLoginPath = (pathname: string, search = '', hash = ''): string => {
  if (isExerciseAdministrationPath(pathname)) return pathname + search + hash;
  if (pathname === '/account/delete') return '/account/delete';
  if (pathname === APPROVAL_PATH && hash) return `${APPROVAL_PATH}${hash}`;
  return POST_LOGIN_PATH;
};

export const buildMagicLoginCallbackUrl = (origin: string): string =>
  `${origin.replace(/\/$/, '')}/auth/verify`;
